import { put } from "@redux-saga/core/effects";
import axios from "axios";

import { AuthService, SignInRequestResponse } from "../../../services/auth";
import { IErrorType } from "../../types/errors.d";
import { signInFailure, signInSuccess } from "../actionCreators";
import { SignInRequestActionType } from "../types";

export function* signInSaga({ payload: { email, password } }: SignInRequestActionType) {
    try {
        const {
            data: { data, success },
        }: SignInRequestResponse = yield AuthService.signIn({ email, password });

        // Get user by token

        if (success) {
            yield put(
                signInSuccess({
                    token: data.token,
                    refresh_token: data.refresh_token,
                    userType: data.userType,
                }),
            );
        }
    } catch (error) {
        let errorType = IErrorType.NATIVE;
        let errorData = error;

        if (axios.isAxiosError(error)) {
            errorType = IErrorType.AXIOS;
            errorData = error.response ? error.response.data : null;
        }

        yield put(signInFailure({ errorType, data: errorData }));
    }
}
